<template>
  <div id="activeModal" @scroll="scroll" :style="{background:atBgColor}">
    <div class="movediv" v-show="ismovediv"></div>
    <span
      class="bag"
      @click.stop="jump()"
      draggable="true"
      @touchstart="bagdown($event)"
      @touchmove="bagmove($event)"
      @touchend="bagup($event)"
      :style="{zIndex:bagZindex,left:bagLeft,top:bagTop}"
    >
      <img src="~assets/images/bags.png" alt />
    </span>
    <div
      id="topImg"
      :class="showTopTit ? 'pdTop' : ''"
      :style="{backgroundColor:atBgColor,backgroundImage:tBgImage}"
    >
      <p class="notice">
        {{activityDec}}
        <span class="rule" @click="rule">规则 ></span>
      </p>
      <div class="topCon" :style="{paddingTop:paddingTop}">
        <p class="uiTitle">{{introduction}}</p>
        <div class="idsss" id="idsss">
          <!-- 这里是组件内部的一些展示 -->
        </div>
        <div ref="activeDesc" class="act" id="act">
          <p class="sign">活动介绍</p>
          <div class="activeDesc">
            <div
              class="imgCons"
              v-for="(item,index) in description"
              style="width:100%;height:auto"
              :key="index"
            >
              <p v-if="item.image">
                <img :src="item.image" alt />
              </p>
              <div class="desc">
                <span class="circle" v-if="item.titleNumber"></span>
                <p v-html="item.descTextForPM">{{item.descTextForPM}}</p>
              </div>
            </div>
          </div>
          <p class="warning" ref="warning">本活动最终解释权归233小游戏所有</p>
        </div>
      </div>
    </div>
    <div class="mask">
      <div class="tipContainer" v-show="tipContainershow">
        <span class="close" @click="close">X</span>
        <h2>提示</h2>
        <p class="tipDetail">{{return_msg}}</p>
        <div
          class="button closeSure"
          @click="toiframe"
        >{{(toiframeflag && toiframeflag != -1) ? '前往获取' : '确定'}}</div>
      </div>
      <div class="awardDetail">
        <span class="close" @click="close">X</span>
        <h2>恭喜获得</h2>
        <div class="wrapper awardwrapper">
          <br />
        </div>
        <p class="awardDesc">
          <span class="yellow"></span>
        </p>
        <div class="button closeSure" @click="tomission">确定</div>
      </div>
    </div>
    <div class="maskimg" @click="maskimgshow = false;" v-show="maskimgshow">
      <div class="firstimg">
        <img :src="showmaskimg" alt />
      </div>
    </div>
    <TurnTable :freeactflag="freeactflag"></TurnTable>
    <MaskMission :missionshow="missionshow"></MaskMission>
  </div>
</template>
<script>
import $ from "jquery";
import { getCookie, setCookie } from "@/utils/base.js";
import { mapState, mapMutations } from "vuex";
import config from "@/../config";
import primaryApi from "@/utils/primaryApi";
import moment from "moment";
import TurnTable from "components/activeModal/turntable";
import MaskMission from "components/activeModal/maskmission";
import active from "@/utils/axios/index";
import qs from "qs";
import Vue from "vue";
import { Icon, NoticeBar } from "vant";
Vue.use(Icon);
Vue.use(NoticeBar);
export default {
  inject: ["reload"],
  props: ['entryObj'], // 模块配置信息
  data() {
    return {
      atBgColor: "", //页面背景颜色
      tBgImage: "", //页面头部的背景图片
      paddingTop: "", //文字距离头部的距离
      description: [], //活动介绍内容
      introduction: "", //头部图片展示的文字
      showmaskimg: "", //进入页面的遮罩logo
      return_msg: "", //提示信息展示
      activityDec: "", //展示活动的状态文本
      toiframeflag: "-1",
      missionshow: false,
      freeactflag: false,
      ismovediv: false, //在页面进行白色遮罩引导的时候展示，每个模块距离头部的距离
      //背包移动时的变量
      moveflag: false, //判断是否可以移动
      offsetleft: 0, //背包距离左边的距离
      offsettop: 0, //背包距离上面的距离
      initleft: 0, //鼠标点击之后按下的点到左边的距离
      inittop: 0, //鼠标点击之后按下的点到上边的距离
      pid: "", //首页获取活动的id
      maskimgshow: false, //图片的活动引导设置
      tipContainershow: false, //提示信息的展示
      awardDetailshow: false, //奖励的展示
      bagZindex: 100, //背包的层级样式
      bagTop: "60%", //背包距离左边的位置
      bagLeft: "-0.1rem", //背包距离头部的位置
      bagwidth: "", //背包的宽度
      activeModalwidth: "", //整个页面的宽度
      wheelcount: 0,
      showTopTit: false //乐园显示顶部导航栏
    };
  },
  components: {
    TurnTable,
    MaskMission
  },
  computed: {
    ...mapState([
      "uuid",
      "activityStatus",
      "activityId",
      "propList",
      "cashcount",
      "goldcount",
      "activeBagMap",
      "firstentry",
      "freeact",
      "guide"
    ])
  },
  created() {
    if (primaryApi.isSource == "pd") {
      //乐园显示顶部导航栏
      this.showTopTit = true;
    }
    this.pid = this.activityId; // 活动id
  },
  watch: {
    freeact() {
      this.freeact.forEach(i => {
        if (i.freeact == true && this.pid == i.activeid) {
          this.freeactflag = i.freeact;
          this.$store.commit({
            type: "setguide",
            guide: this.freeactflag
          });
          if (this.freeactflag) {
            $(".dailySerpluss").css("z-index", "105");
          } else {
            $(".dailySerpluss").css("z-index", "0");
          }
          document.querySelector(".actbox").style.zIndex = 101;
          var actall = document.querySelectorAll(".actbox");
          if (actall.length > 1) {
            actall[1].nextSibling.style.zIndex = 0;
          }
          setTimeout(() => {
            let freeact = document.querySelector(".freeact").offsetTop;
            $("#topImg").animate(
              { top: -freeact + $(".bubble1").height() },
              "slow"
            );
          }, 100);
          document.querySelector("#activeModal").style.overflow = "hidden";
        } else if (i.freeact == -1 || i.freeact == 0 || !i.freeact) {
          this.showImg();
        }
      });
    }
  },
  mounted() {
    //233乐园后退回调
    window["goBackResult"] = result => {
      if (result == "failed") {
        //乐园后退失败则关闭界面
        primaryApi.closeActivity();
      }
    };
    this.entry();
    this.getbag();
  },
  methods: {
    //页面的滚动事件
    scroll() {
      var scrollHeight = Math.round(
        document.querySelector("#topImg").getBoundingClientRect().bottom
      ); //这个是整个内部内容底部距离最大父元素头部的距离
      var bottomHeight = window.innerHeight; //这个是整个页面的距离
      if (scrollHeight == bottomHeight) {
        //进行埋点的设置
        this.$tea("event_activemodal_bot", {
          activityId: this.pid,
          guide: this.guide ? this.guide : false
        });
      }
    },
    //页面初始化渲染
    entry() {
        this.introduction = this.entryObj.activityClient.introduction; //头部的文字展示
        this.description = this.entryObj.description; //活动介绍的内容
        this.showmaskimg = this.entryObj.activityClient.prizeDisplay; //遮罩logo
        document.title = this.entryObj.activityClient.productName; //活动题目
        //配置页面样式
        this.atBgColor = "#" + this.entryObj.activityClient.backendRGB;
        this.paddingTop = this.entryObj.activityClient.space / 100 + "rem";
        this.tBgImage = "url(" + this.entryObj.activityClient.topImage + ")";
        this.showstatus(this.entryObj.activityServer); //判断活动状态，展示头部文字
        //活动状态进行储存
        this.$store.commit({
            type: "setactivityStatus",
            activityStatus: this.entryObj.activityServer.activityStatus
        });
        //判断是否有转盘
        var wheelflag = this.entryObj.contentShow.filter(i => i.split("_")[0] == "wheel");
        if (wheelflag.length > 0) {
            this.showactive(); //判断是否展示转盘引导
        } else {
            this.showImg(); //判断是否展示图片引导
        }
        this.$nextTick(() => {
            this.$tea("event_activemodal_show", {
                activityId: this.entryObj.activityClient.activityId,
                guide: this.guide ? this.guide : false
            }); //数据埋点
        });
        this.entryObj.contentShow.forEach(i => {
            if (i.split("_")[0] == "wheel") {
                this.wheelcount++;
            }
        });
        this.$choosecomponent(this.entryObj.contentShow.slice(0, 1));
        // 第一条数据渲染完成后再渲染其他
        setTimeout(() => {
            this.$choosecomponent(this.entryObj.contentShow.slice(1));
        }, 500);
    },
    //头部活动时间的展示
    showstatus(data) {
      //头部活动状态展示
      if (data.activityStatus == 0) {
        this.activityDec =
          "活动开启时间：" + data.startTime.split(":")[0] + "点";
      } else if (data.activityStatus == 1) {
        this.activityDec = "活动结束时间：" + data.endTime.split(":")[0] + "点";
      } else if (data.activityStatus == 2) {
        this.activityDec =
          "活动已结束，关闭时间：" + data.closeTime.split(":")[0] + "点";
      } else {
        this.activityDec = "活动已关闭";
      }
    },
    //转盘引导
    showactive() {
      var firstentryarrCook = getCookie("firstentryarr");
      var entryarr = firstentryarrCook ? JSON.parse(firstentryarrCook) : [];
      var time = new Date().getTime();
      if (entryarr.length == 0) {
        //否
        var obj = {
          activeid: this.pid,
          time: time,
          firstEntry: true
        };
        entryarr.push(obj);
      } else {
        //有数据，判断是不是同一个活动id
        for (var i = 0, j = entryarr.length; i < j; i++) {
          if (entryarr[i].activeid == this.pid) {
            var flags = entryarr[i];
          }
        }
        if (!flags) {
          //判断不是同一个活动id
          var obj = {
            activeid: this.pid,
            time: time,
            firstEntry: true
          };
          entryarr.push(obj);
        } else {
          //是同一个活动id，遍历数据，进行修改
          for (var i = 0, j = entryarr.length; i < j; i++) {
            if (entryarr[i].activeid == flags.activeid) {
              var yesterdaytime = moment(new Date(flags.time)).format(
                "YYYY-MM-DD"
              );
              var nowtime = moment(time).format("YYYY-MM-DD");
              if (yesterdaytime != nowtime) {
                //不是当天数据替换
                entryarr[i].firstEntry = true;
                entryarr[i].time = time;
              } else {
                entryarr[i].firstEntry = false;
                this.showImg();
              }
            }
          }
        }
      }
      setCookie("firstentryarr", JSON.stringify(entryarr));
      this.$store.commit({
        type: "setfirstEntry",
        firstEntry: entryarr
      });
    },
    //任务引导
    tomission() {
      this.$nextTick(() => {
        $(".mask").hide();
        if (this.$parent.$parent.missionflag) {
          $("#topImg").css("top", "0");
          this.freeact.forEach(i => {
            if (i.activeid == this.pid) {
              i.freeact = false;
            }
          });
          this.$store.commit({
            type: "setfreeact",
            freeact: this.freeact
          });
          this.freeactflag = false;
          $(".dailySerpluss").css("z-index", "0");
          $(".hand").css("display", "none");
          this.missionshow = true;
          // document.querySelector(".missionsign").scrollIntoView({ block: "center", behavior: "smooth" });
          let topDistance = $("#todayActive").offset().top; //滚动距离
          if (primaryApi.isSource == "pd") { //乐园要扣除顶部导航栏高度
            topDistance = topDistance - $(".topTit").height();
          }
          document.getElementById("activeModal").scroll({
            top: topDistance,
            left: 0,
            behavior: "smooth"
          });
          document.querySelector(".showmission").style.zIndex = 106;
          document.querySelector(".actbox").style.zIndex = 0;
          document.querySelector(".missionhand").style.display = "block";
        } else {
          this.missionshow = false;
          document.querySelector(".showmission").style.zIndex = 0;
          this.bagZindex = 200;
          document.querySelector(".missionhand").style.display = "none";
        }
      });
    },
    // 白色遮罩的跳转
    toiframe() {
      $(".mask").hide();
      this.toiframeflag = $(".mask").attr("toiframeflag");
      this.$nextTick(() => {
        if (this.toiframeflag == -1 || !this.toiframeflag) {
          //没有跳转的地方
          return;
        }
        for (var i = 0; i < $("#idsss")[0].children.length; i++) {
          for (var j = 0; j < $("#idsss")[0].children[i].attributes.length; j++) {
            if ($("#idsss")[0].children[i].attributes[j].name == "awardidpointer") {
              if ($("#idsss")[0].children[i].attributes[j].nodeValue == this.toiframeflag) {
                var el = $("#idsss")[0].children[i];
              }
            }
          }
        }
        var aniname = el.children[0].attributes[0].name;
        if (!el) {
          //没有与之匹配的iframe
          return;
        }
        let topDistance = el.offsetTop; //滚动距离
        if (primaryApi.isSource == "pd") { //乐园要扣除顶部导航栏高度
          topDistance = topDistance - $(".topTit").height();
        }
        document.getElementById("activeModal").scroll({
          top: topDistance,
          left: 0,
          behavior: "smooth"
        });
        // el.scrollIntoView({
        //   block: "center",
        //   duration: 2000,
        //   behavior: "smooth"
        // });
        this.ismovediv = true;
        setTimeout(() => {
          if (el.children[0].id == "mask") {
            //今日任务
            el.children[0].style.display = "block";
            el.children[0].style.animation = "white-" + aniname + " 1s linear";
          }
        }, 1000);

        setTimeout(() => {
          el.children[0].style.display = "none";
          el.children[0].style.animation = "";
          this.ismovediv = false;
        }, 2200);
      });
    },
    //展示图片
    showImg() {
      if (!this.showmaskimg) {
        //没有照片
      } else {
        //获取昨天的时间判断是否有数据
        var lastlist = getCookie("localtime")
          ? JSON.parse(getCookie("localtime"))
          : [];
        var time = new Date().getTime();
        if (lastlist.length != 0) {
          //有数据
          var flag;
          for (var i = 0; i < lastlist.length; i++) {
            if (lastlist[i].activeid == this.pid) {
              flag = lastlist[i];
            }
          }
          if (!flag) {
            //判断不是同一个活动id
            var obj = {
              activeid: this.pid,
              time: time
            };
            lastlist.push(obj);
            this.maskimgshow = true;
          } else {
            //是同一个活动id，遍历数据，进行修改
            for (var i = 0; i < lastlist.length; i++) {
              if (lastlist[i].activeid == flag.activeid) {
                var yesterdaytime = moment(new Date(flag.time)).format(
                  "YYYY-MM-DD"
                );
                var nowtime = moment(new Date()).format("YYYY-MM-DD");
                if (yesterdaytime != nowtime) {
                  //不是当天数据替换;
                  lastlist[i].time = time;
                  this.maskimgshow = true;
                }
              }
            }
          }
        } else {
          //没有数据进行展示第一次
          var obj = {
            activeid: this.pid,
            time: time
          };
          this.maskimgshow = true;
          lastlist.push(obj);
        }
        setCookie("localtime", JSON.stringify(lastlist));
      }
    },
    //获取背包的数据
    getbag() {
      this.$nextTick(() => {
        active
          .getPropInfo(
            config.API_HOST + "/apiserv/api/activity/getPropInfo",
            qs.stringify({ uuid: this.uuid, propType: 7 })
          )
          .then(res => {
            if (res.return_code == 200) {
              this.$store.commit({
                type: "setpropList",
                propList: res.data.propList
              });
              this.$store.commit({
                type: "setcashcount",
                cashcount: res.data.cashCount
              });
              this.$store.commit({
                type: "setgoldcount",
                goldcount: res.data.goldCount
              });
              this.activeBag();
            } else {
              this.tipConshow(res.return_msg);
            }
          })
          .catch(() => {
            var propList = []; //道具背包
            var cashcount = 0; //现金
            var goldcount = 0; //金币
            var activeBagMap = {};
            this.$store.commit({
              type: "setpropList",
              propList: propList
            });
            this.$store.commit({
              type: "setactivebagmap",
              activeBagMap: activeBagMap
            });
            this.$store.commit({
              type: "setcashcount",
              cashcount
            });
            this.$store.commit({
              type: "setgoldcount",
              goldcount
            });
          });
      });
    },
    //将背包转换为map
    activeBag() {
      var map = {};
      var dest = [];
      for (var a of this.propList) {
        if (!map[a.propId]) {
          dest.push({
            propId: a.propId,
            propNum: a.propNum,
            propName: a.propName
          });
          map[a.propId] = a;
        } else {
          for (var b of dest) {
            if (b.propId == a.propId) {
              b.propNum += a.propNum;
              map[a.propId].propNum = b.propNum;
              break;
            }
          }
        }
      }
      this.$store.commit({
        type: "setactivebagmap",
        activeBagMap: map
      });
    },
    //展示弹框信息
    tipConshow(return_msg) {
      this.ismask = true;
      this.tipContainershow = true;
      this.awardDetailshow = false;
      this.return_msg = return_msg;
    },
    //遮罩消失（点击提示框或者奖励框的右上角的关闭）
    close() {
      $(".mask").hide();
    },
    //点击规则进行页面滚动
    rule() {
      // this.$refs.activeDesc.scrollIntoView();
      let topDistance = $("#act").offset().top; //滚动距离
      if (primaryApi.isSource == "pd") { //乐园要扣除顶部导航栏高度
        topDistance = topDistance - $(".topTit").height();
      }
      document.getElementById("activeModal").scroll({
        top: topDistance,
        left: 0,
        behavior: "auto"
      });
      this.$tea("event_activemodal_taprule", {
        activityId: this.activityId,
        guide: this.guide ? this.guide : false
      }); //数据埋点
    },
    // 背包跳转
    jump() {
      window.location.href = location.origin + "/bag/";
      this.$tea("event_activemodal_gobag", {
        activityId: this.pid,
        guide: this.guide ? this.guide : false
      }); //数据埋点
    },
    //背包的移动事件
    bagdown(e) {
      this.offsetleft = $(".bag")[0].offsetLeft;
      this.offsettop = $(".bag")[0].offsetTop;
      this.initleft = e.touches[0].clientX;
      this.inittop = e.touches[0].clientY;
      this.moveflag = true;
      this.bagwidth = $(".bag").width();
      this.activeModalwidth = $("#activeModal").width();
    },
    bagmove(e) {
      e.preventDefault();
      this.bagZindex = 150;
      var moveX = e.touches[0].clientX - this.initleft;
      var moveY = e.touches[0].clientY - this.inittop;
      var noticeheight = $(".notice").height();
      var bagheight = $(".bag").height();
      var activeModalheight = $("#activeModal").height();
      if (this.moveflag) {
        var disX = moveX + this.offsetleft;
        var disY = moveY + this.offsettop;
        if (disX <= 0) {
          disX = 0 - 10;
        } else if (this.bagwidth + disX > this.activeModalwidth) {
          disX = this.activeModalwidth - this.bagwidth + 10;
        }
        if (disY <= noticeheight) {
          disY = noticeheight - 5;
        } else if (bagheight + disY > activeModalheight) {
          disY = activeModalheight - bagheight + 15;
        }
        this.bagLeft = disX / (100 * this.activeModalwidth / 375) + "rem";
        this.bagTop = disY / (100 * this.activeModalwidth / 375) + "rem";
      }
    },
    bagup() {
      if (
        $(".bag")[0].offsetLeft + this.bagwidth / 2 <
        this.activeModalwidth / 2
      ) {
        this.bagLeft = "-0.1rem";
      } else {
        this.bagLeft =
          (this.activeModalwidth - this.bagwidth) / (100 * this.activeModalwidth / 375) + 0.1 + "rem";
      }
      this.moveflag = false;
    },
    //刷新
    refreshClick() {
      this.reload();
    },
    //后退
    goBack() {
      if (primaryApi.isSource == "pd") {
        //乐园环境
        primaryApi.goBack();
      }
    }
  }
};
</script> 
<style lang="less" scoped>
button,
p {
  margin: 0;
  padding: 0;
}
button {
  display: block;
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
}
#activeModal {
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
.movediv {
  width: 100%;
  height: 0.2rem;
}
.bag {
  position: fixed;
  display: block;
  img {
    width: 0.91rem;
    height: 0.91rem;
    opacity: 0.95;
  }
}
#topImg {
  position: relative;
  height: auto;
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
  width: 100%;
}
.pdTop {
  background-position: 0 0.46rem !important;
  padding-top: 0.46rem;
}
.notice {
  width: 100%;
  height: 0.4rem;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  line-height: 0.4rem;
  font-size: 0.14rem;
  padding: 0 0.14rem;
  box-sizing: border-box;
}
.topCon {
  width: 100%;
  height: auto;
  padding: 0 0.12rem;
  box-sizing: border-box;
}
.uiTitle {
  width: 100%;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  color: #fff;
  font-size: 0.14rem;
  margin: 0;
}
.rule {
  width: 0.62rem;
  height: 0.24rem;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0.14rem;
  line-height: 0.24rem;
  text-align: center;
  margin-top: 0.08rem;
  color: #fff;
  float: right;
}
.act {
  width: 100%;
  height: auto;
  border-radius: 0.1rem;
  box-sizing: border-box;
  position: relative;
  padding-top: 0.05rem;
  margin-top: 0.2rem;
}
.sign {
  width: 100%;
  position: absolute;
  height: 0.37rem;
  background: url("~assets/images/sign.png") no-repeat top;
  background-size: contain;
  text-align: center;
  font-size: 0.18rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(249, 249, 249, 1);
  line-height: 0.3rem;
  z-index: 19;
}
.activeDesc {
  width: 100%;
  background: #fff;
  border-radius: 0.1rem;
  margin-top: 0.2rem;
  padding: 0.2rem 0.12rem 0.24rem 0.12rem;
  box-sizing: border-box;
}
.activeDesc .imgCons {
  width: 100%;
  height: auto;
  font-size: 0.12rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 0.18rem;
}
.desc {
  width: 100%;
  height: auto;
  font-size: 0.15rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 0.18rem;
  display: flex;
  margin: 0.1rem 0;
}
.desc p {
  width: 90%;
  flex: 1;
}
.circle {
  display: block;
  width: 0.05rem;
  height: 0.05rem;
  background: rgba(253, 203, 24, 1);
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  border-radius: 50%;
  text-align: center;
  margin-right: 0.1rem;
  margin-top: 0.05rem;
}
.warning {
  text-align: center;
  font-size: 0.12rem;
  line-height: 0.42rem;
  color: #bd541c;
  opacity: 0.8;
  margin-top: 0.2rem;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.75);
  display: none;
}
h2 {
  display: block;
  width: 100%;
  height: 0.2rem;
  font-size: 0.17rem;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 0.2rem;
  margin-top: 0.1rem;
  text-align: center;
}
.tipContainer {
  width: 3.12rem;
  height: 1.79rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.16rem;
  margin: auto;
  padding: 0.16rem;
  text-align: center;
  margin-top: -0.72rem;
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -1.56rem;
}
.close {
  float: right;
  width: 0.16rem;
  height: 0.16rem;
  background: rgba(255, 255, 255, 1);
  font-size: 0.16rem;
  color: #c0c0c0;
  position: absolute;
  right: 0.16rem;
}
.tipDetail {
  width: 80%;
  height: 0.33rem;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 0.3rem;
  margin-left: 10%;
  margin-top: 0.07rem;
}
.closeSure {
  width: 100%;
  height: 0.4rem;
  background: rgba(255, 142, 31, 1);
  border-radius: 0.4rem;
  font-size: 0.12rem;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.4rem;
  margin-top: 0.22rem;
  border: 0;
}
.awardDetail {
  width: 3.12rem;
  min-height: 1.79rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.16rem;
  padding: 0.16rem;
  text-align: center;
  position: absolute;
  top: 50%;
  margin-left: -1.55rem;
  left: 50%;
  z-index: 99999999;
}
.awardDesc {
  width: 100%;
  margin-top: 0.05rem;
  height: auto;
  background: rgba(247, 247, 247, 1);
  border-radius: 0.04rem;
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 0.18rem;
  padding: 0.1rem 0;
  margin-top: 0.1rem;
  display: none;
}
.yellow {
  color: #ff8e1f;
}
.maskimg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.75);
}
.firstimg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.topTit {
  width: 100%;
  height: 0.46rem;
  line-height: 0.46rem;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 0.05rem;
}
.refresh {
  // position: absolute;
  // right: 0.05rem;
  // top: 0;
  height: 100%;
  width: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 0;
}
.refresh img {
  width: 0.18rem;
  height: 0.18rem;
}
.refresh span {
  color: #515151;
  font-size: 0.06rem;
  line-height: 0.2rem;
  // transform: scale(0.9, 0.9);
  margin-top: -0.1rem;
}
.van-notice-bar {
  width: 100%;
  text-align: center;
  font-size: 0.16rem;
  padding: 0 0.1rem;
}
</style>
<style scoped="scoped">
.navText >>> .van-notice-bar__content {
  text-align: center;
  min-width: 100%;
}
</style>